import React, { useState, useEffect } from 'react';
import { Plus, Search, Edit2, Trash2, Eye, EyeOff, Building, User, Briefcase } from 'lucide-react';
import axiosInstance from '@/axios';
import Modal from '@/pages/Other/Modal';

const Requestgrievanceredressal = () => {
    const [testimonials, setTestimonials] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [modalType, setModalType] = useState('create');
    const [selectedTestimonial, setSelectedTestimonial] = useState(null);
    const [selectedIds, setSelectedIds] = useState([]);

    const [formData, setFormData] = useState({
        id: '',
        name: '',
        designation: '',
        company: '',
        testimonial: '',
        status: 1,
    });

    useEffect(() => {
        fetchTestimonials();
    }, []);

    const fetchTestimonials = async () => {
        try {
            setLoading(true);
            const response = await axiosInstance.get('/request/grievance-redressal');
            console.log('Fetched testimonials:', response.data);
            setTestimonials(response.data.data || []);
        } catch (error) {
            console.error('Failed to fetch testimonials:', error);
        } finally {
            setLoading(false);
        }
    };

    const filteredTestimonials = testimonials.filter(testimonial =>
        testimonial.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        testimonial.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
        testimonial.contactNumber.toLowerCase().includes(searchTerm.toLowerCase()) ||
        testimonial.alternateNumber.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            if (modalType === 'create') {
                await axiosInstance.post('/testimonials', formData);
            } else if (modalType === 'edit') {
                await axiosInstance.put(`/testimonials/${formData.id}`, formData);
            }

            await fetchTestimonials();
            resetForm();
            setShowModal(false);
        } catch (error) {
            console.error('Error submitting testimonial:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleEdit = (testimonial) => {
        setFormData(testimonial);
        setSelectedTestimonial(testimonial);
        setModalType('edit');
        setShowModal(true);
    };

    const handleView = (testimonial) => {
        setSelectedTestimonial(testimonial);
        setModalType('view');
        setShowModal(true);
    };

    const handleDelete = async (ids) => {
        // ids can be a single id or an array of ids
        const idsToDelete = Array.isArray(ids) ? ids : [ids];

        if (!window.confirm(`Are you sure you want to delete ${idsToDelete.length} record(s)?`)) return;

        setLoading(true);
        try {
            if (idsToDelete.length > 1) {
                // Bulk delete endpoint
                await axiosInstance.post(`/request/grievance-redressal/bulk-delete`, { ids: idsToDelete });
            } else {
                // Single delete endpoint
                await axiosInstance.delete(`/request/grievance-redressal/${idsToDelete[0]}`);
            }
            setTestimonials(prev => prev.filter(t => !idsToDelete.includes(t.id)));
            setSelectedIds([]); // Clear selection after delete
        } catch (error) {
            console.error('Error deleting testimonials:', error);
        } finally {
            setLoading(false);
        }
    };


    const toggleStatus = async (id) => {
        if (!window.confirm('Are you sure you want to change the status of this testimonial?')) return;
        setLoading(true);
        try {
            const testimonial = testimonials.find(t => t.id === id);
            const updatedStatus = testimonial.status === 1 ? 0 : 1;
            await axiosInstance.put(`/testimonials/${id}`, { ...testimonial, status: updatedStatus });
            await fetchTestimonials();
        } catch (error) {
            console.error('Error toggling status:', error);
        } finally {
            setLoading(false);
        }
    };

    const resetForm = () => {
        setFormData({
            id: '',
            name: '',
            designation: '',
            company: '',
            testimonial: '',
            status: ''
        });
        setSelectedTestimonial(null);
    };

    const openCreateModal = () => {
        resetForm();
        setModalType('create');
        setShowModal(true);
    };
    return (
        // <div className="min-h-screen bg-gradient-to-br from-indigo-50 via-white to-cyan-50">
        <div className="container mx-auto px-5 mt-3">
            {/* Header */}
            <h1 className="text-2xl font-bold mb-4 p-4 bg-[#264b82] text-white rounded-md mt-0">
                Grievanceredressal - Requests
            </h1>
            {/* Statistics Cards */}
            {/* <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
                <div className="bg-white rounded-xl shadow-lg px-6 py-4 border-l-4 border-[#264b82]">
                    <div className="flex items-center justify-between">
                        <div>
                            <p className="!text-gray-600 text-sm font-medium">Active</p>
                            <p className="text-2xl font-bold !text-[#264b82]">{testimonials.filter(t => t.status === 1).length}</p>
                        </div>
                        <Eye className="h-6 w-6 text-[#264b82]" />
                    </div>
                </div>
                <div className="bg-white rounded-xl shadow-lg px-6 py-4 border-l-4 border-[#264b82]">
                    <div className="flex items-center justify-between">
                        <div>
                            <p className="!text-gray-600 text-sm font-medium">Inactive</p>
                            <p className="text-2xl font-bold !text-[#264b82]">{testimonials.filter(t => t.status === 0).length}</p>
                        </div>
                        <EyeOff className="h-6 w-6 text-[#264b82]" />
                    </div>
                </div>
                <div className="bg-white rounded-xl shadow-lg px-6 py-4 border-l-4 border-[#264b82]">
                    <div className="flex items-center justify-between">
                        <div>
                            <p className="!text-gray-600 text-sm font-medium">Total</p>
                            <p className="text-2xl font-bold !text-[#264b82]">{testimonials.length}</p>
                        </div>
                        <User className="h-6 w-6 text-[#264b82]" />
                    </div>
                </div>
            </div> */}

            <div className="flex flex-col md:flex-row gap-4 items-center justify-between">
                <div className="relative flex-1 max-w-md">
                    <Search className="!absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-5 w-5" />
                    <input
                        type="text"
                        placeholder="Search Experts..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        className="w-full !pl-10 pr-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
                    />
                </div>
                {selectedIds.length > 0 && (
                    <button
                        onClick={() => handleDelete(selectedIds)}
                        className="bg-red-500 text-white px-4 py-2 rounded-md mb-3"
                    >
                        Delete Selected ({selectedIds.length})
                    </button>
                )}

                {/* <button
                    onClick={openCreateModal}
                    className="bg-[#264b82] text-white px-6 py-3 rounded-xl hover:from-indigo-700  flex items-center gap-2 shadow-lg hover:shadow-xl"
                >
                    <Plus className="h-5 w-5" />
                    Add Experts
                </button> */}
            </div>

            {/* Testimonials Table */}
            <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
                <div className="px-6 py-4 bg-gray-50 border-b">
                    <h2 className="text-xl font-semibold text-gray-800">All Grievanceredressal  Requests</h2>
                </div>

                {loading ? (
                    <div className="flex justify-center items-center py-12">
                        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600"></div>
                    </div>
                ) : (
                    <div className="instructor-table overflow-x-auto">
                        <table className="table-width-100">
                            <thead className="">
                                <tr>
                                    <th>
                                        <input
                                            type="checkbox"
                                            onChange={(e) => {
                                                if (e.target.checked) {
                                                    setSelectedIds(filteredTestimonials.map(t => t.id));
                                                } else {
                                                    setSelectedIds([]);
                                                }
                                            }}
                                            checked={
                                                selectedIds.length > 0 &&
                                                selectedIds.length === filteredTestimonials.length
                                            }
                                        />
                                    </th>
                                    <th className=" uppercase">Name</th>
                                    <th className=" uppercase">email</th>
                                    <th className=" uppercase">Phone</th>
                                    <th className=" uppercase">Alternate Number</th>
                                    <th className=" uppercase">Category</th>
                                    <th className=" uppercase">Sub Category</th>
                                    <th className=" uppercase">concern</th>
                                    {/* <th className=" uppercase">Actions</th> */}
                                </tr>
                            </thead>
                            <tbody className="divide-y divide-gray-200">
                                {filteredTestimonials.map((testimonial) => (
                                    <tr key={testimonial.id} className="hover:bg-gray-50 transition-colors">
                                        <td>
                                            <input
                                                type="checkbox"
                                                checked={selectedIds.includes(testimonial.id)}
                                                onChange={(e) => {
                                                    if (e.target.checked) {
                                                        setSelectedIds((prev) => [...prev, testimonial.id]);
                                                    } else {
                                                        setSelectedIds((prev) =>
                                                            prev.filter(id => id !== testimonial.id)
                                                        );
                                                    }
                                                }}
                                            />
                                        </td>
                                        <td className="cell">
                                            <div className="flex items-center">
                                                {/* <div className="h-10 w-10 bg-[#264b82] rounded-full flex items-center justify-center text-white font-semibold">
                                                    {testimonial?.name}
                                                </div> */}
                                                <div className="ml-3">
                                                    <p className="font-medium !text-gray-900">{testimonial?.name}</p>
                                                </div>
                                            </div>
                                        </td>
                                        <td className="cell">
                                            {testimonial?.email}
                                        </td>
                                        <td className="cell">
                                            {testimonial?.contactNumber}
                                        </td>
                                        <td className="cell">
                                            {testimonial?.alternateNumber}
                                        </td>
                                        <td className="cell">
                                            {testimonial?.category}
                                        </td>
                                        <td className="cell">
                                            {testimonial?.subCategory}
                                        </td>
                                        <td className="cell">
                                            {testimonial?.concern}
                                        </td>
                                        {/* <td className="cell">
                                            <div className="flex space-x-2">
                                                {/* <button
                                                    onClick={() => handleView(testimonial)}
                                                    className="p-2 text-[#264b82] hover:bg-blue-50 rounded-lg transition-colors"
                                                    title="View"
                                                >
                                                    <Eye className="h-4 w-4" />
                                                </button> 
                                                <button
                                                    onClick={() => handleEdit(testimonial)}
                                                    className="p-2 text-[#264b82] hover:bg-indigo-50 rounded-lg transition-colors"
                                                    title="Edit"
                                                >
                                                    <Edit2 className="h-4 w-4" />
                                                </button>
                                                <button
                                                    onClick={() => handleDelete(testimonial.id)}
                                                    className="p-2 text-[#264b82] hover:bg-red-50 rounded-lg transition-colors"
                                                    title="Delete"
                                                >
                                                    <Trash2 className="h-4 w-4" />
                                                </button>
                                            </div>
                                        </td> */}
                                        <td>
                                            <button onClick={() => handleDelete(testimonial.id)}>Delete</button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>

                        {filteredTestimonials.length === 0 && (
                            <div className="text-center py-12">
                                <p className="!text-gray-500 text-lg">No data found</p>
                            </div>
                        )}
                    </div>
                )}
            </div>

            {/* Modal */}
            {showModal && (
                <Modal isOpen={showModal} onClose={() => setShowModal(false)}>
                    <>
                        <div className="bg-[#264b82] px-6 py-4 text-white">
                            <h3 className="text-xl font-semibold">
                                {modalType === 'create' && 'Add New Expert'}
                                {modalType === 'edit' && 'Edit Expert'}
                                {modalType === 'view' && 'View Expert'}
                            </h3>
                        </div>

                        <div className="p-6">
                            {modalType === 'view' ? (
                                <div className="space-y-4">
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Name</label>
                                        <p className="!text-gray-900 bg-gray-50 p-3 rounded-lg">{selectedTestimonial?.name}</p>
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Designation</label>
                                        <p className="!text-gray-900 bg-gray-50 p-3 rounded-lg">{selectedTestimonial?.designation}</p>
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Company</label>
                                        <p className="!text-gray-900 bg-gray-50 p-3 rounded-lg">{selectedTestimonial?.company}</p>
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Testimonial</label>
                                        <p className="!text-gray-900 bg-gray-50 p-3 rounded-lg min-h-[100px]">{selectedTestimonial?.testimonial}</p>
                                    </div>
                                </div>
                            ) : (
                                <div className="space-y-4">
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">Name *</label>
                                            <input
                                                type="text"
                                                name="name"
                                                value={formData.name}
                                                onChange={handleInputChange}
                                                required
                                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
                                            />
                                        </div>
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">Designation *</label>
                                            <input
                                                type="text"
                                                name="designation"
                                                value={formData.designation}
                                                onChange={handleInputChange}
                                                required
                                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
                                            />
                                        </div>
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Company *</label>
                                        <input
                                            type="text"
                                            name="company"
                                            value={formData.company}
                                            onChange={handleInputChange}
                                            required
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
                                        />
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Testimonial *</label>
                                        <textarea
                                            name="testimonial"
                                            value={formData.testimonial}
                                            onChange={handleInputChange}
                                            required
                                            rows={4}
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
                                        />
                                    </div>

                                    {modalType === 'edit' && (
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">Status</label>
                                            <select
                                                name="status"
                                                value={formData.status}
                                                onChange={handleInputChange}
                                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
                                            >
                                                <option value={1}>Active</option>
                                                <option value={0}>Inactive</option>
                                            </select>
                                        </div>
                                    )}
                                </div>
                            )}

                            <div className="flex justify-end space-x-3 mt-6 pt-6 border-t">
                                <button
                                    type="button"
                                    onClick={() => setShowModal(false)}
                                    className="px-4 py-2 text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors"
                                >
                                    {modalType === 'view' ? 'Close' : 'Cancel'}
                                </button>
                                {modalType !== 'view' && (
                                    <button
                                        type="submit"
                                        onClick={handleSubmit}
                                        disabled={loading}
                                        className="px-6 py-2 bg-[#264b82] text-white rounded-lg  disabled:opacity-50"
                                    >
                                        {loading ? 'Saving...' : modalType === 'create' ? 'Create' : 'Update'}
                                    </button>
                                )}
                            </div>
                        </div>
                    </>
                </Modal>
            )}
        </div>
        // </div>
    );
};

export default Requestgrievanceredressal;